const Device = (function() {
  const mobileMaxWidth = 767;
  const tabletMinWidth = 768;
  const tabletMaxWidth = 991;
  const desktopSmallMinWidth = 992;
  const desktopLargeMinWidth = 1200;

  function isMobile() {
    return window.innerWidth <= mobileMaxWidth;
  }

  function isTablet() {
    return window.innerWidth >= tabletMinWidth && window.innerWidth <= tabletMaxWidth;
  }

  function isDesktopSmall() {
    return window.innerWidth >= desktopSmallMinWidth;
  }

  function isDesktopLarge() {
    return window.innerWidth >= desktopLargeMinWidth;
  }

  return {
    isMobile,
    isTablet,
    isDesktopSmall,
    isDesktopLarge
  }
})();

function ElementIsInViewPort(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

const darkGray = '#4A4A4A';
const lightGray = '#F9F7F3';

export {
  Device,
  ElementIsInViewPort,
  darkGray,
  lightGray,
}


// WEBPACK FOOTER //
// ./src/modules/shared.js